import { LegacySectionConfig } from 'theme/components/ProfileCard/ProfileCardAdapter'
import AssignCompaniesAutocomplete from '../EditModeComponents/AssignCompaniesAutocomplete'
import AssignOwnerAutocomplete from '../EditModeComponents/AssignOwnerAutocomplete'

/**
 * Field configuration for Contact profiles.
 * Returns sections compatible with ProfileCardAdapter.
 *
 * @param contact - The contact entity being displayed/edited (using any to handle dynamic fields)
 * @param organizations - List of organizations for the autocomplete
 * @param handleChange - Change handler for field updates
 */
export const contactFieldConfigSections = (
  contact: any | undefined,
  organizations: any[],
  handleChange: (fieldName: string, newValue: any) => void
): LegacySectionConfig[] => {
  // Safely extract owner - can be string or array depending on data
  const ownerValue = contact?.owner
  const ownerArray = Array.isArray(ownerValue) ? ownerValue : ownerValue ? [ownerValue] : []

  const sections: LegacySectionConfig[] = [
    {
      sectionLabel: 'Information',
      fields: [
        {
          name: 'owner',
          label: 'Owner',
          type: 'component',
          component: AssignOwnerAutocomplete,
          componentProps: {
            userId: ownerArray,
            label: '',
            context: 'owner',
            multiple: false,
          },
        },
        {
          name: 'firstName',
          label: 'First Name',
          type: 'text',
          gridProps: { xs: 12, sm: 4 },
        },
        {
          name: 'middleName',
          label: 'Middle Name',
          type: 'text',
          gridProps: { xs: 12, sm: 4 },
        },
        {
          name: 'lastName',
          label: 'Last Name',
          type: 'text',
          gridProps: { xs: 12, sm: 4 },
        },
        {
          name: 'name',
          label: 'Full Name',
          type: 'text',
          disabled: true,
        },
        {
          name: 'title',
          label: 'Title',
          type: 'text',
        },
        {
          name: 'organizations',
          label: 'Related Organizations',
          type: 'component',
          component: AssignCompaniesAutocomplete,
          componentProps: {
            label: '',
            context: 'organizations',
            value: [], // Will be populated by getFieldValue
          },
        },
      ],
    },
    {
      sectionLabel: 'Contact Info',
      fields: [
        {
          name: 'phone',
          label: 'Mobile Phone',
          type: 'text',
        },
        {
          name: 'officePhone',
          label: 'Office Phone',
          type: 'text',
        },
        {
          name: 'email',
          label: 'Email',
          type: 'text',
        },
        {
          name: 'billingEmail',
          label: 'Billing Email',
          type: 'text',
        },
        {
          name: 'linkedinProfile',
          label: 'LinkedIn',
          type: 'text',
        },
        {
          name: 'street',
          label: 'Street',
          type: 'text',
        },
        {
          name: 'city',
          label: 'City',
          type: 'text',
          gridProps: { xs: 12, sm: 6 },
        },
        {
          name: 'state',
          label: 'State',
          type: 'text',
          gridProps: { xs: 12, sm: 3 },
        },
        {
          name: 'zip',
          label: 'Zip',
          type: 'text',
          gridProps: { xs: 12, sm: 3 },
        },
      ],
    },
    {
      sectionLabel: 'Additional Info',
      fields: [
        {
          name: 'summary',
          label: 'Summary',
          type: 'text',
          multiline: true,
          gridProps: { xs: 12 },
        },
      ],
    },
  ]

  return sections
}
